import { css } from 'styled-components';
import {
  grid, gridUnit, getSpacing, SpacingName, BreakpointQueryName, ThemedFunctor,
} from '@doveit/lego';

export const secondaryNavigation: ThemedFunctor = ({
  theme,
}) => css`
  border-bottom: 1px solid ${theme.palettes.neutrals.light};
`;

export const header: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, [0, SpacingName.NEGATIVE_SMALLER])}
`;

export const main: ThemedFunctor = ({
  theme,
}) => css`
  ${gridUnit(theme, { size: { LG: 8 / 12 } })}
  ${getSpacing.padding(theme, [0, SpacingName.SMALLER])}
`;

export const secondary: ThemedFunctor = ({
  theme,
}) => css`
  display: none;
  ${gridUnit(theme, { size: { LG: 4 / 12 } })}
  ${getSpacing.padding(theme, [0, SpacingName.SMALLER, SpacingName.SMALLER, SpacingName.SMALLER])}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block;
  }
`;
